import { Component, ViewChild, ElementRef, Input, OnChanges } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { MiniTracker } from 'huddyapi';

@Component({
	selector: 'treatment-widget',
	templateUrl: 'treatment-widget.html',
	styleUrls: ['./treatment-widget.scss'],
	inputs: ['data', 'caller',  'clearSubject$' ]
})
export class TreatmentWidget implements OnChanges {


	@Input() clearSubject$ : Subject<boolean>;
	@Input() data: MiniTracker;
  clearSub : Subscription;
	caller: any;
  value : boolean;

	yesterdayLoaded : boolean;

	constructor() {

	}

    onChange() {
      this.data.currentVal = (this.value) ? 1 : 0;
    }

    getYesterday() : string {
      return this.data.yesterdayValue ? +this.data.yesterdayValue == 1 ? 'Taken' : 'Not Taken' : undefined;
    }

    getYesterdayText() {
      return 'yesterday';
    }


    ngOnChanges(changes) {
      console.log( 'TreatmentWidget', 'yesterdayValue',  changes);

      if (this.clearSubject$ && !this.clearSub) {
        console.log( 'EvidenceWidget', 'in ngOnChanges setting clearSub');
          this.clearSub = this.clearSubject$.subscribe(b => {
            console.log( 'EvidenceWidget', 'in clearSubSubscribe', b, this.data);
              if (b) {		   
              }
          })
      }
    }

}
